import { checkoutAuthHeaders } from '../checkout/checkoutAuthHeaders';
import { productEffectivePrice } from '../productPricing';

export function serverRowsToItems(rows, productsByKey) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => {
    const categorySlug = String(row.category_slug || '');
    const productId = String(row.product_external_id || '');
    const live = productsByKey?.get(`${categorySlug}:${productId}`);
    return {
      categorySlug,
      productId,
      name: live ? String(live.name || '') : '',
      image: live ? String(live.image || '') : '',
      price: live ? productEffectivePrice(live) : 0,
    };
  });
}

export function localItemPayload(item) {
  return {
    category_slug: item.categorySlug,
    product_external_id: item.productId,
    categorySlug: item.categorySlug,
    productId: item.productId,
  };
}

export async function wishlistApiPost(action, extra = {}) {
  let r;
  try {
    r = await fetch('/api/customer.php', {
      method: 'POST',
      headers: checkoutAuthHeaders(),
      body: JSON.stringify({ action, ...extra }),
    });
  } catch {
    return { ok: false, error: 'Network error — server unreachable.' };
  }
  let d = {};
  try {
    d = await r.json();
  } catch {
    return { ok: false, error: 'Invalid response from server.' };
  }
  if (!r.ok || !d.success) {
    return { ok: false, error: d.error || 'Request failed.', status: r.status };
  }
  return { ok: true, data: d };
}
